import "./vessel_financing.css";
import { ReactComponent as LogoTransparent } from "../../Asset/transparent.svg";
import { ReactComponent as SolutionIcon } from "../../Asset/Group 13009.svg";
import { ReactComponent as SuitcaseIcon } from "../../Asset/suitcase-duotone 1.svg";
import { ReactComponent as HandshakeIcon } from "../../Asset/handshake-duotone 1.svg";
import { ReactComponent as UserIcon } from "../../Asset/UsersFour.svg";
import { ReactComponent as BoatIcon } from "../../Asset/boat-duotone 1.svg";
import { ReactComponent as UploadIcon } from "../../Asset/upload-cloud-02.svg";
import { ReactComponent as ArrowIcon } from "../../Asset/Vector.svg";

const VesselFinancing = () => {
  return (
    <div className="vessel_financing">
      <div className="wrapper">
        <div className="hero">
          <div className="box">
            <p>Vessel Financing</p>
            <h2>Empowering Maritime Growth Through Smarter Finance</h2>
            <button>Start Your Journey <ArrowIcon/> </button>
          </div>
        </div>
      </div>
      
      <div className="wrapper">
        <div className="what-we-offer">
          <h2>What we offer</h2>
          <div className="card">
            <p>
              Our Vessel Financing Division provides full investment and asset
              finance services tailored to the shipping and maritime sectors.
              Whether you're purchasing a single vessel or expanding a fleet, we
              help you navigate the complex world of ship finance with clarity.
            </p>
            <button>Get started <ArrowIcon/> </button>
          </div>
        </div>
      </div>

      <div className="wrapper">
        <div className="assets-wrapper">
          <div className="card">
            <span>
              <h3>Asset-Based Financing</h3>
              <p>
                The vessel serves as the primary collateral in the financing
                structure.
              </p>
            </span>
            <div className="icon"><BoatIcon/></div>
          </div>
          <div className="card">
            <span>
              <h3>Flexible Financing Structures</h3>
              <ul>
                <li>
                  Loan Agreements – The buyer repays through structured
                  installments.
                </li>
                <li>
                  Joint Ownership – Equity is shared between financier and buyer.
                </li>
              </ul>
            </span>
            <div className="icon"><SuitcaseIcon/></div>
          </div>
          <div className="card">
            <span>
              <h3>Comprehensive Deal Support</h3>
              <p>
                From risk management to deal closure, we support every stage of
                the transaction.
              </p>
            </span>
            <div className="icon"><HandshakeIcon/></div>
          </div>
          <div className="card">
            <span>
              <h3>Expert Guidance</h3>
              <p>
                Our experienced team delivers financial intelligence and
                customized strategies to help clients make confident, data-driven
                decisions.
              </p>
            </span>
            <div className="icon"><UserIcon/></div>
          </div>
        </div>
      </div>

      <div className="wrapper">
        <div className="stakeholder-approach">
          <h2>Stakeholder-First Approach</h2>
          <div className="wrapper-1">
            <h2>
              We believe that strong relationships are the key to long-term
              success.
            </h2>
            <div className="btn">
              <button>Start your journey <ArrowIcon/> </button>
            </div>
          </div>
          <div className="wrapper-2">
            <div className="card">
              <h3>Client-Focused Service</h3>
              <p>
                We take time to understand each client's goals and challenges to
                deliver tailored solutions.
              </p>
            </div>
            <div className="card">
              <h3>Experienced Professionals</h3>
              <p>
                Our team consists of some of the best in the business, with a
                consistent track record of delivering value.
              </p>
            </div>
            <div className="card">
              <h3>End-to-End Global Offering</h3>
              <p>
                From vessel acquisition through financing and beyond, we are with
                you at every step.
              </p>
            </div>
            <div className="card">
              <h3>Community Commitment</h3>
              <p>
                We actively engage with the wider maritime community and support
                initiatives in the regions where we operate.
              </p>
            </div>
          </div>
        </div>
      </div>
      
      <div className="wrapper">
        <div className="vessel-solution">
          <div className="card-1">
            <h2>OUR IMPACT</h2>
            <h3>
              Our vessel financing solutions are designed to fuel sustainable
              growth for maritime businesses at every stage from first-time
              operators to established fleet owners.
            </h3>
            <p>
              We remain focused on delivering real-world impact by aligning
              financing with our clients' long-term strategic goals
            </p>
            <div className="logo">
              <SolutionIcon/>
            </div>
          </div>
          <div className="card-2">
            <span>
              <h3>Access to Capital for Vessel Acquisition</h3>
              <p>
                We help clients overcome financial barriers to entry by providing
                capital solutions specifically
              </p>
            </span>
            <span>
              <h3>Scalable Financing Models</h3>
              <p>
                Our flexible loan and joint ownership structures support both
                one-time acquisitions and long-term fleet expansion strategies.
              </p>
            </span>
            <span>
              <h3>Strategic Guidance for Market Navigation</h3>
              <p>
                Through expert advisory and data-driven insights, we empower
                clients to capitalize on emerging market trends and seize new
                opportunities with confidence.
              </p>
            </span>
            <span>
              <h3>Supporting Industry Evolution</h3>
              <p>
                We partner with maritime stakeholders to facilitate innovation,
                operational efficiency, and access to global markets, creating a
                ripple effect of growth across the value chain.
              </p>
            </span>
          </div>
        </div>
      </div>

      <div className="wrapper">
        <div className="financing-request">
          <div className="banner">
            <div className="banner-text">
              <h3>Financing Request Form</h3>
              <p>
                To initiate a financing discussion, please prepare the following:
              </p>
            </div>
            <LogoTransparent />
          </div>
          <div className="form-card">
            <div className="form-group">
              <span className="form-field">
                <label>First Name</label>
                <input type="text" placeholder="First name" defaultValue="Anthony" className="form-input" />
              </span>
              <span className="form-field">
                <label>Last Name</label>
                <input type="text" placeholder="Last name" defaultValue="Monyei" className="form-input" />
              </span>
            </div>
            <span className="form-field">
              <label>Email</label>
              <input type="email" placeholder="Email" defaultValue="example@email.com" className="form-input" />
            </span>
            <div className="country-group">
              <span className="form-field">
                <label>Phone Number</label>
                <div className="phone-flex-row">
                  <select className="form-select country-select">
                    <option value="NGN">🇳🇬 NGN</option>
                    <option value="USA">🇺🇸 USA</option>
                  </select>
                  <input type="tel" placeholder="Enter" className="form-input phone-input" />
                </div>
              </span>
            </div>
            <span className="form-field">
              <label>Company Name</label>
              <input type="text" placeholder="Company name" className="form-input" />
            </span>
            <span className="form-field">
              <label>Vessel Type</label>
              <select className="form-select">
                <option>Select</option>
              </select>
            </span>
            <span className="form-field">
              <label>Purchase Price</label>
              <input type="text" placeholder="Purchase Price" className="form-input" />
            </span>
            <span className="form-field">
              <label>Financing Type</label>
              <select className="form-select">
                <option>Select</option>
              </select>
            </span>
            <span className="form-field">
              <label>Letter of Credit</label>
              <div className="form-file-upload">
                <UploadIcon/>
                <div className="upload-text">
                  <p className="pdf">Drop pdf here,</p>
                  <p className="browse"> or browse</p>
                  </div>
                  <p>Supports: PDF</p>
              </div>
            </span>
            <span className="form-field">
              <label>Financial Background</label>
              <div className="form-file-upload">
                <UploadIcon/>
                <div className="upload-text">
                  <p className="pdf">Drop pdf here,</p>
                  <p className="browse"> or browse</p>
                  </div>
                  <p>Supports: PDF</p>
              </div>
            </span>
            <button className="form-submit">SUBMIT</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VesselFinancing;